var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M83.25 45C83.25 23.8751 66.1249 6.75 45 6.75C23.8751 6.75 6.75 23.8751 6.75 45C6.75 66.1249 23.8751 83.25 45 83.25C66.1249 83.25 83.25 66.1249 83.25 45ZM90 45C90 69.8528 69.8528 90 45 90C20.1472 90 0 69.8528 0 45C0 20.1472 20.1472 0 45 0C69.8528 0 90 20.1472 90 45ZM31.5 24.3961V65.5453C31.5 67.3349 33.4881 68.4083 34.9844 67.4264L66.4873 46.7546C67.8449 45.8637 67.8406 43.872 66.4791 42.987L34.9762 22.5096C33.4794 21.5367 31.5 22.6109 31.5 24.3961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoAdd);
export default __webpack_public_path__ + "static/media/videoAdd.132231a3c15b42e83cf4e112f995b0b4.svg";
export { ForwardRef as ReactComponent };